module.exports = __webpack_public_path__ + "res/Roboto-Thin-webfontd41d.eot?e9994cc48306582d47373cc67cd397fc";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Thin-webfontd41d.eot
// module id = 57
// module chunks = 0